import * as React from "react";

const SvgIcnFullscreen = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g fill="currentColor" fillRule="evenodd">
            <path d="M5 20a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v3.794l4.646-4.648a.5.5 0 01.638-.057l.07.057a.5.5 0 010 .708L6.208 19H10a.5.5 0 010 1H5zM20 4a.5.5 0 01.5.5v5a.5.5 0 01-1 0V5.706l-4.646 4.648a.5.5 0 01-.638.057l-.07-.057a.5.5 0 010-.708L18.792 5H15a.5.5 0 010-1h5z" />
        </g>
    </svg>
);

export default SvgIcnFullscreen;
